import { useState } from 'react';
import InlineEmailOtpVerification from '../common/InlineEmailOtpVerification';

export default function SignUp() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (verifiedEmail !== email.trim().toLowerCase()) {
      setError('Please verify your email with OTP before signing up.');
      return;
    }
    
    try {
      const response = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          password
        }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      setSuccess(true);
      // Optionally redirect to login or automatically login
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <div className="text-red-500 text-sm">
          {error}
        </div>
      )}
      {success && (
        <div className="text-green-500 text-sm">
          Registration successful! Please login.
        </div>
      )}
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Name
        </label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="mt-1 block w-full rounded-[5px] border bg-gray-700 shadow-sm focus:border-black focus:ring-black px-3 py-2 sm:text-sm"
          required
        />
        <div className="mt-3">
          <InlineEmailOtpVerification
            email={email}
            verifiedEmail={verifiedEmail}
            onVerifiedEmailChange={setVerifiedEmail}
            context="signup"
            mode="manual"
          />
        </div>
      </div>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 block w-full rounded-[5px] border bg-gray-700 shadow-sm focus:border-black focus:ring-black px-3 py-2 sm:text-sm"
          required
        />
      </div>
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
          Password
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 block w-full rounded-[5px] border bg-gray-700 shadow-sm focus:border-black focus:ring-black px-3 py-2 sm:text-sm"
          required
        />
      </div>
      <button
        type="submit"
        disabled={verifiedEmail !== email.trim().toLowerCase()}
        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-[5px] shadow-sm text-sm font-medium text-white bg-gray-700 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
      >
        Sign Up
      </button>
    </form>
  );
}
